<app-header></app-header>
<div class="principal-container">
  <div class="banner-container row">
    <div class="imagen-container col-md-12 col-sm-12">
      <img
        mat-card-image
        src="../../../../assets/images/Render4_1.jpg"
        class="img-banner"
      />
      <!-- <div class="left-arrow-container">
        <mat-icon class="icon-arrow">keyboard_arrow_left</mat-icon>
      </div>
      <div class="right-arrow-container">
        <mat-icon class="icon-arrow">keyboard_arrow_right</mat-icon>
      </div>

      <div class="button-container">
        <button mat-button class="btn btn-comprar-plan" (click)="goToPlanes()">
          Leer más
        </button>
      </div> -->
    </div>
  </div>

  <div class="options-container">
    <div class="eventos-container">
      <div class="cards-container">
        <div class="novedades-container">
          <div class="row">
            <div class="col" *ngFor="let n of news">
              <div class="textos">
                <a
                  [href]="n.link_noticia"
                  target="_blank"
                  style="text-decoration: none;"
                >
                  <img src="{{ n.link_imagen_noticia }}" class="img-mall" />
                  <div class="titulo-novedad">
                    {{ truncateText(n.titulo_noticia) }}
                  </div>
                </a>

                <div class="fecha-novedad">{{ n.categoria_noticia }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
